<!--
 * @Description: 
 * @Date: 2022-02-22 11:08:53
 * @LastEditTime: 2022-09-14 14:53:24
 * @FilePath: \admin_hilo\src\components\main\components\header-bar\custom-bread-crumb\custom-bread-crumb.vue
-->
<template>
  <div class="custom-bread-crumb">
    <Breadcrumb :style="{ fontSize: `${fontSize}px` }">
      <!-- <BreadcrumbItem v-for="item in list" :to="item.path" :key="`bread-crumb-${item.name}`"> -->
      <BreadcrumbItem v-for="item in list" :key="`bread-crumb-${item.name}`">
        <common-icon style="margin-right: 4px;" :type="item.icon || ''" />
        <router-link :to="item.path">{{ showTitle(item) }}</router-link>
      </BreadcrumbItem>
    </Breadcrumb>
  </div>
</template>
<script>
import { showTitle } from "@/libs/util";
import "./custom-bread-crumb.less";
import CommonIcon from "@/components/common-icon";

export default {
  name: "customBreadCrumb",
  components: {
    CommonIcon
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    fontSize: {
      type: Number,
      default: 14
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  created() {
    // console.log(this.list, "list");
  },
  methods: {
    showTitle(item) {
      return showTitle(item, this);
    },
    isCustomIcon(iconName) {
      return iconName.indexOf("_") == 0;
    },
    getCustomIconName(iconName) {
      return iconName.slice(1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/main/components/header-bar/custom-bread-crumb/custom-bread-crumb.vue